<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "logout",
  created() {
    this.logout()
  },
  data: function() {
    return {
    };
  },
  methods: {
    logout: function() {
      this.$ls.set("token", "")
      this.$ls.set("username", "")
      this.$router.go('/')
    },
  }
};
</script>
